<template>
  <v-app>
    <v-main>
      <router-view />
      <CookieConsentLayer />
    </v-main>
  </v-app>
</template>

<script>

import CookieConsentLayer from '@/components/CookieConsentLayer.vue';

export default {
  name: 'App',
  components: {
    CookieConsentLayer,
  },
  created() {
    console.log('browser lan', navigator.languages);
  },
};
</script>

<style lang="scss">
.container {
 padding: 0px !important;
}

body {
  overflow-x: hidden !important;
};

</style>
